// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"272":"c38cc3ef","740":"c6bba8de"}[chunkId] + ".chunk.js";
};